module.exports = __webpack_public_path__ + "static/media/team4.d3ebb8f1.jpg";